<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none rounded-pill outline-0"
                       placeholder="Chercher un client..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- Identification Column -->
                    <ng-container matColumnDef="identification">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Identification</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.identification }}
                        </td>
                    </ng-container>

                    <!-- Social Reason Column -->
                    <ng-container matColumnDef="socialReason">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Raison Sociale</th>
                        <td mat-cell *matCellDef="let element">           
                                  <a [routerLink]="['/client-details', element.id]">
                            {{ element.socialReason }}
                        </a></td>
                    </ng-container>

                    <!-- HeadQuarter Column -->
                    <ng-container matColumnDef="headQuarter">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Siège social</th>
                        <td mat-cell *matCellDef="let element"> {{ element.headQuarter }}</td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </th>
                        <td mat-cell *matCellDef="let element"> {{ element.address }}</td>
                    </ng-container>

                    <ng-container matColumnDef="billingAddress">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse de facturation  </th>
                        <td mat-cell *matCellDef="let element"> {{ element.billingAddress }}</td>
                    </ng-container>


                    <!-- Mail Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                        <td mat-cell *matCellDef="let element"> {{ element.flag ? "Actif" : "Inactif" }}</td>
                    </ng-container>

                    <!-- Activity Field Column -->
                    <ng-container matColumnDef="activityField">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Secteur d'activité</th>
                        <td mat-cell *matCellDef="let element"> {{ element.activityField }}</td>
                    </ng-container>
                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes </th>
                        <td mat-cell *matCellDef="let element"> {{ element.note }}</td>
                    </ng-container>
                    <ng-container matColumnDef="ice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ICE </th>
                        <td mat-cell *matCellDef="let element"> {{ element.ice }}</td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser les détails"
                                        matTooltipPosition="above" (click)="openViewModel(element)"
                                >
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Edit" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Delete" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>

</mat-card>
<!-- Add modal template for new client -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Nouveau Client
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveClient()">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Identification</mat-label>
                            <input matInput formControlName="identification" placeholder="Ex. 123456789">
                            <mat-error *ngIf="form.get('identification')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Raison Sociale</mat-label>
                            <input matInput formControlName="socialReason" placeholder="Ex. Exemple Corp">
                            <mat-error *ngIf="form.get('socialReason')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Siège social</mat-label>
                            <input matInput formControlName="headQuarter" placeholder="Ex. Exemple Corp">
                            <mat-error *ngIf="form.get('headQuarter')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="form.get('phone')?.hasError('required')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Fax</mat-label>
                            <input matInput formControlName="fax" placeholder="Ex. +123-0123456789">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="mail" placeholder="Ex. info@example.com">
                            <mat-error *ngIf="form.get('mail')?.hasError('required')">Champ obligatoire</mat-error>
                            <mat-error *ngIf="form.get('mail')?.hasError('email')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Secteur d'activité</mat-label>
                            <input matInput formControlName="activityField" placeholder="Ex. Agriculture">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>ICE</mat-label>
                            <input matInput formControlName="ice" placeholder="Ex. 1234567890123456789012">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <textarea matInput formControlName="address"
                                      placeholder="Ex. 123 Main St, Springfield"></textarea>
                            <mat-error *ngIf="form.get('address')?.hasError('required')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse de facturation</mat-label>
                            <textarea matInput formControlName="billingAddress"
                                      placeholder="Ex. 456 Elm St, Springfield"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="flag">
                                <mat-option [value]="1">Actif</mat-option>
                                <mat-option [value]="0">Inactif</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Notes</mat-label>
                            <textarea matInput formControlName="note"
                                      placeholder="Note concernant le client"></textarea>
                            <mat-error *ngIf="form.get('note')?.hasError('required')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>
<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Client
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="updateClient()">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Identification</mat-label>
                            <input matInput formControlName="identification" placeholder="Ex. 123456789">
                            <mat-error *ngIf="editForm.get('identification')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Raison Sociale</mat-label>
                            <input matInput formControlName="socialReason" placeholder="Ex. Example Corp">
                            <mat-error *ngIf="editForm.get('socialReason')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Siège social</mat-label>
                            <input matInput formControlName="headQuarter" placeholder="Ex. 123 Main St, Springfield">
                            <mat-error *ngIf="editForm.get('headQuarter')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>ICE</mat-label>
                            <input matInput formControlName="ice" placeholder="Ex. 1234567">
                            <mat-error *ngIf="editForm.get('ice')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. 123-456-7890">
                            <mat-error *ngIf="editForm.get('phone')?.hasError('required')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Fax</mat-label>
                            <input matInput formControlName="fax" placeholder="Ex. 098-765-4321">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="mail" placeholder="Ex. info@example.com">
                            <mat-error *ngIf="editForm.get('mail')?.hasError('required')">Champ obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('mail')?.hasError('email')">Champ obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Champ d'activité</mat-label>
                            <input matInput formControlName="activityField" placeholder="Ex. Software Development">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="flag">
                                <mat-option [value]="true">Active</mat-option>
                                <mat-option [value]="false">Inactive</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="address"
                                      placeholder="Ex. 123 Main St, Springfield"></textarea>
                            <mat-error *ngIf="editForm.get('address')?.hasError('required')">Address is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse de facturation</mat-label>
                            <textarea matInput formControlName="billingAddress"
                                      placeholder="Ex. 456 Elm St, Springfield"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Note</mat-label>
                            <textarea matInput formControlName="note"
                                      placeholder="Ex. Note "></textarea>
                            <mat-error *ngIf="editForm.get('note')?.hasError('required')">Note
                                required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Client Details Modal -->
<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <h5 class="fw-bold mx-3">Détails Client</h5>
    <div class="row m-3">
      <!-- Identification -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Identification :</div>
        <p>{{ form.get('identification')?.value }}</p>
      </div>

      <!-- Raison sociale -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Raison sociale :</div>
        <p>{{ form.get('socialReason')?.value }}</p>
      </div>

      <!-- Si ClientDto complet -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Siège :</div>
        <p>{{ form.get('headQuarter')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">ICE :</div>
        <p>{{ form.get('ice')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Téléphone :</div>
        <p>{{ form.get('phone')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Fax :</div>
        <p>{{ form.get('fax')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Email :</div>
        <p>{{ form.get('mail')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Domaine d'activité :</div>
        <p>{{ form.get('activityField')?.value }}</p>
      </div>


      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Adresse :</div>
        <p>{{ form.get('address')?.value }}</p>
      </div>

      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Adresse facturation :</div>
        <p>{{ form.get('billingAddress')?.value }}</p>
      </div>
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Créé le :</div>
        <p>{{ form.get('creationDate')?.value | date:'short' }}</p>
      </div>

    <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Modifié le :</div>
        <p>{{ form.get('updateDate')?.value | date:'short' }}</p>
    </div>

    </div>
  </mat-card>
</ng-template>



